// grantReward (TECH_BASELINE §6.3): ống DUY NHẤT trao thưởng. Idempotent theo `key` (sổ claimed),
// kế hoạch thuần ở src/sim/rewards, áp trong một batch(), ghi một dòng Truyền Âm, hẹn autosave.
// Loot idle của Lịch Luyện đi đường riêng (inventory.receive) vì cần tự mặc / bộ lọc theo từng món.
import { batch } from '@preact/signals';
import { planReward, type Reward } from '@sim/rewards/plan';
import { isClaimed, markClaimed } from './modules/ledger';
import { creditWallet } from './modules/wallet';
import { addGoods, receive } from './modules/inventory';
import { logLine, type LogChannel } from './modules/log';
import { flush } from './persistence';

export type RewardSource = 'idle' | 'quest' | 'story' | 'market' | 'dev';

export interface GrantOptions {
  /** Khóa chống trao hai lần (lưu trong core.ledger.claimed). */
  key?: string;
  log?: { channel: LogChannel; key: string; params?: Record<string, string | number> };
}

export type GrantResult = 'granted' | 'alreadyClaimed';

export function grantReward(
  _source: RewardSource,
  rewards: readonly Reward[],
  o: GrantOptions = {},
): GrantResult {
  if (o.key && isClaimed(o.key)) return 'alreadyClaimed';
  const plan = planReward(rewards);
  batch(() => {
    creditWallet(plan.currency);
    addGoods(plan.goods);
    if (plan.items.length) receive(plan.items, { autoEquip: false, online: true });
    if (o.key) markClaimed(o.key);
    if (o.log) logLine(o.log.channel, o.log.key, { ...plan.currency, ...(o.log.params ?? {}) });
  });
  void flush();
  return 'granted';
}
